import { Typography } from '@mui/material';
import { getOwnCompanyProducts } from 'lib/api';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import EnhancedTab from 'lib/designSystem/TabSimulation';
import { validatePermissions } from 'lib/functions/utils';
import { Product } from 'lib/types/models';
import ConfirmingRequests from 'pages/Finance/Components/Financing/Confirming';
import ActiveDocuments from 'pages/Finance/Components/Financing/CreditLine/components/Recieved/components/ShoppingDialog/components/ActiveDocuments';
import CreditsRequested from 'pages/Finance/Components/Financing/CreditsRequests/components/Recieved';
import FactoringRequestsRecieved from 'pages/Finance/Components/Financing/Factoring/components/Recieved';
import Accounts from 'pages/Finance/Components/Payments/components/Accounts';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { AuthState } from 'services/redux/authSlice';

import DataHubSummary from '../DataHub';
import OperativeProfile from './components/OperativeProfile';
import SGR from './components/SGR';

type Params = {
  id: string;
  businessId: string;
  page: string;
};

interface OperativeInfoProps {
  businessIdentifier: string;
}

const OperativeInfo = (props: OperativeInfoProps) => {
  const { id } = useParams<Params>();
  const dispatch = useDispatch();
  const user = useSelector((state: { auth: AuthState }) => state.auth.user);
  const { businessIdentifier } = props;
  const [loading, setLoading] = React.useState(false);
  const businessIdentifierReal = businessIdentifier ?? id;
  const [businessId, setBusinessId] = useState('');
  const [ownProducts, setOwnProducts] = useState<Product['typeId'][]>([]);

  const setUp = async () => {
    if (!businessIdentifierReal) {
      alert('No se ha encontrado el id del cliente');
      return;
    }
    setBusinessId(businessIdentifierReal);
  };

  const fetchCompanyProducts = async () => {
    setLoading(true);
    try {
      const availableProducts = await getOwnCompanyProducts(dispatch);
      const productIds = availableProducts.map(
        (product: Product) => product.typeId,
      );
      setOwnProducts(productIds);
    } catch (error) {
      console.error(error);
      setOwnProducts([]);
    }
    setLoading(false);
  };

  const tabs = [
    ...(['factoring', 'confirming', 'credit', 'sgr'].some((product) =>
      ownProducts.includes(product),
    )
      ? [
          {
            label: 'Inicio',
            component: (
              <OperativeProfile businessIdentifier={businessIdentifierReal} />
            ),
          },
        ]
      : []),
    {
      label: 'DataHub',
      component: <DataHubSummary businessIdentifier={businessIdentifierReal} />,
    },
    ...(ownProducts.includes('factoring')
      ? [
          {
            label: 'Factoring',
            component: (
              <div>
                <FactoringRequestsRecieved
                  businessIdentifierProp={businessIdentifierReal}
                />
              </div>
            ),
          },
        ]
      : []),
    ...(ownProducts.includes('confirming')
      ? [
          {
            label: 'Confirming',
            component: (
              <ConfirmingRequests businessIdentifier={businessIdentifierReal} />
            ),
            disabled: !validatePermissions(
              user,
              'financing_confirming_receive',
            ),
          },
        ]
      : []),
    ...(ownProducts.includes('credit')
      ? [
          {
            label: 'Créditos',
            component: (
              <CreditsRequested
                businessIdentifierProp={businessIdentifierReal}
              />
            ),
          },
        ]
      : []),
    ...(ownProducts.includes('sgr')
      ? [
          {
            label: 'Garantías',
            component: <SGR />,
          },
        ]
      : []),
    ...(['factoring', 'credit'].some((product) => ownProducts.includes(product))
      ? [
          {
            label: 'Cartera',
            component: (
              <div style={{ padding: '20px 0px' }}>
                <Typography variant="body1" fontWeight={600}>
                  Factoring
                </Typography>
                <ActiveDocuments
                  businessIdentifier={businessId}
                  notDialog
                  request={{
                    productType: 'factoring',
                  }}
                />
                <Typography variant="body1" fontWeight={600}>
                  Créditos
                </Typography>
                <ActiveDocuments
                  businessIdentifier={businessId}
                  notDialog
                  request={{
                    productType: 'credit',
                  }}
                />
              </div>
            ),
          },
        ]
      : []),
    ...(['factoring', 'credit', 'confirming'].some((product) =>
      ownProducts.includes(product),
    )
      ? [
          {
            label: 'Cuentas',
            component: (
              <Accounts businessIdentifier={businessIdentifierReal} profile />
            ),
          },
        ]
      : []),
  ];

  useEffect(() => {
    void setUp();
    void fetchCompanyProducts();
  }, []);

  if (loading) return <CenteredCircularProgress />;

  return (
    <div>
      <EnhancedTab startValue={0} tabs={tabs} />
    </div>
  );
};

export default OperativeInfo;
